import oRequest from '@/libsV2/request.js';
const URL = {
    PERFORMANCE_SEARCH    :'report/performance/search',//业绩在线 搜索
    PERFORMANCE_OVERVIEW    :'report/performance/overview',//业绩在线 概览
    PERFORMANCE_TREND    :'report/performance/trend',//业绩在线 趋势
    PERFORMANCE_RANK    :'report/performance/rank',//业绩在线 榜单
    PERFORMANCE_WARNING    :'report/performance/warning',//业绩在线 预警
    CHANNEL_CONTRIBUTION: "report.Channel/contribution",//渠道贡献
    CHANNEL_RANK: "report.Channel/rank", //渠道榜单
    FOLLOW_ORDER :"report/FollowOrder/follow", //跟单分析
    FOLLOW_BEHAVIOR :"report/followorder/behavior", //跟单行为
    REPORT_STATISTICS:"hvac/discuss/reportstatistics",//洽谈统计
    REPORT_RANK:"hvac/discuss/reportrank",//洽谈排名
    // REPORT_RANK_EXPORT:"hvac/discuss/reportrankexport",//洽谈导出
    REPORT_RANK_EXPORT:"hvac/discuss/reportsignexport",//洽谈导出3.0
    REPORT_FEED_EXPORT:"hvac/discuss/reportfeedexport",//洽谈导出2.0
    REPORT_RANK_PRO: "hvac/discuss/projectrankexport",   // 体验间导出
}

export default{
    getPerformanceSearch(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PERFORMANCE_SEARCH,oData)
    },
    getPerformanceOverview(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PERFORMANCE_OVERVIEW,oData)
    },
    getPerformanceTrend(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PERFORMANCE_TREND,oData)
    },
    getPerformanceRank(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PERFORMANCE_RANK,oData)
    },
    getPerformanceWarning(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PERFORMANCE_WARNING,oData)
    },
    getChannelContribution(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CHANNEL_CONTRIBUTION,oData)
    },
    getChannelRank(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CHANNEL_RANK,oData)
    },
    getFollowOrder(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.FOLLOW_ORDER,oData)
    },
    getFollowBehavior(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.FOLLOW_BEHAVIOR,oData)
    },
    getReportStatistics(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORT_STATISTICS,oData)
    },
    getReportRank(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORT_RANK,oData)
    },
    // 体验间3.0导出
    getReportExc(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORT_RANK_EXPORT,oData)
    },
    // 体验间2.0导出
    getReportExcFeed(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORT_FEED_EXPORT,oData)
    },
    getportExcel(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.REPORT_RANK_PRO,oData)
    },
}
